import DynamicControlsApi from 'client/api/v2/DynamicControlsApi';

export const createDynamicControlsModule = () => ({
  namespaced: true,

  actions: {
    getDynamicControlsDropdownOptions(context, payload) {
      return DynamicControlsApi.getDynamicControlsDropdownOptions(
        payload.resource,
        payload.filterField,
        payload.filterValue,
      );
    },
  },
});

export default createDynamicControlsModule();
